<h2 mat-dialog-title class="rn-header">
  <mat-icon aria-hidden="true" color="primary">campaign</mat-icon>
  <span class="rn-title">{{ note.title }}</span>
  <span class="rn-version" *ngIf="note.version">v{{ note.version }}</span>
</h2>

<div mat-dialog-content class="rn-content">
  <div class="rn-date" *ngIf="note.releaseDate">
    Released {{ note.releaseDate | date: 'mediumDate' }}
  </div>

  <ul class="rn-highlights" *ngIf="note.highlights?.length">
    <li *ngFor="let h of note.highlights" class="rn-highlight">
      <mat-icon class="rn-highlight-icon" [ngClass]="'rn-cat-' + h.category">{{ iconFor(h.category) }}</mat-icon>
      <span class="rn-highlight-label" [ngClass]="'rn-cat-' + h.category">{{ h.category }}</span>
      <span class="rn-highlight-text">{{ h.text }}</span>
    </li>
  </ul>

  <markdown class="rn-body" [data]="note.contents"></markdown>
</div>

<div mat-dialog-actions class="rn-actions">
  <mat-checkbox *ngIf="allowDismiss" [(ngModel)]="dontShowAgain" [disabled]="saving">
    Don't show this again
  </mat-checkbox>

  <span class="rn-spacer"></span>

  <button mat-button *ngIf="allowDismiss" [disabled]="saving" (click)="close()">
    Remind me later
  </button>
  <button mat-flat-button color="primary" cdkFocusInitial [disabled]="saving" (click)="confirm()">
    <mat-spinner *ngIf="saving" diameter="16" class="rn-spinner"></mat-spinner>
    Got it
  </button>
</div>
